import {
  defaultLayoutTracker,
  trackerChartCardId,
} from "../../../main/themes/defaultLayoutData";
import {
  CardInfo,
  CardTypesEnum,
  ChildrenTypeEnum,
  ItemLayoutsConfig,
} from "../types";

export function isTrackerCard(card: Pick<CardInfo, "id" | "type" | "childrenType">): boolean {
  return (
    Number(card.type) === CardTypesEnum.Tracker ||
    card.childrenType === ChildrenTypeEnum.TrackerChart ||
    card.id === trackerChartCardId ||
    card.id.startsWith("Tracker-")
  );
}

export function filterTrackerFromCardsConfig(cards: CardInfo[]): CardInfo[] {
  return cards.filter((card) => !isTrackerCard(card));
}

export function filterTrackerFromLayouts(
  layouts: ItemLayoutsConfig,
): ItemLayoutsConfig {
  const newLayouts = { ...layouts, layouts: { ...layouts.layouts } };
  (Object.keys(newLayouts.layouts) as (keyof typeof newLayouts.layouts)[]).forEach(
    (breakpoint) => {
      newLayouts.layouts[breakpoint] = newLayouts.layouts[breakpoint]?.filter(
        (layout) =>
          layout.cardId !== trackerChartCardId &&
          !layout.cardId.startsWith("Tracker-"),
      );
    },
  );
  return newLayouts;
}

export function restoreTrackerInLayouts(
  layouts: ItemLayoutsConfig,
): ItemLayoutsConfig {
  const hasTrackerLayout = Object.values(layouts.layouts).some((breakpoint) =>
    breakpoint?.some(
      (layout) =>
        layout.cardId === trackerChartCardId ||
        layout.cardId.startsWith("Tracker-"),
    ),
  );

  if (hasTrackerLayout) {
    return layouts;
  }

  const newLayouts = { ...layouts, layouts: { ...layouts.layouts } };
  (
    Object.keys(newLayouts.layouts) as (keyof typeof newLayouts.layouts)[]
  ).forEach((breakpoint) => {
    const trackerLayout = defaultLayoutTracker[breakpoint];
    if (!trackerLayout) return;

    newLayouts.layouts[breakpoint] = [
      ...(newLayouts.layouts[breakpoint] ?? []),
      trackerLayout,
    ];
  });

  return newLayouts;
}
